import 'react-toastify/dist/ReactToastify.min.css';
import { Button, MenuItem, Select, TextField, FormControl, InputLabel } from '@mui/material';
import React, { useContext, useRef, useState } from 'react';
import { Add } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { LanguageContext } from '../../../libs/Context';
import { SendInvitation } from '../../actions/employee_actions';
import Tooltip from '@mui/material/Tooltip';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { ValidateEmail } from '../../../libs/Validation';
import Loading from '../../../components/Common/Loaders/FullWidthLoader/Loading';
import { Toasters } from '../../../UiComponents/Toasters';

const EmployeeListSlider = (props) =>
{
	const { language } = useContext(LanguageContext);
	const blockRef = useRef<boolean>(false);
	const [ email, setEmail ] = useState<string>('');
	const [ addedEmail, setAddedEmail ] = useState<any>([]);
	const [ loading, setLoading ] = useState<boolean>(false);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const [ title, setTitle ] = useState<string>('copy');
	const [ selectRole, setSelectRole ] = useState<string>('company');
	const companyUrl = `${process.env.REACT_APP_SHAREURL_COMPANY}/${window.btoa(userData?.companyId)}/${window.btoa(userData?.userId)}`;
	const employeeUrl = `${process.env.REACT_APP_SHAREURL_EMPLOYEE}/${window.btoa(userData?.companyId)}`;
	const handleEmail = (e:any) =>
	{
		setEmail(e.target.value);
	};

	const handleAdd = (e:any) =>
	{
		e.preventDefault();
		if (email === '')
		{
			toast.error(`${language?.pleaseEnterEmail}`, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
		else if (email === userData.email)
		{
			toast.error(`${language?.cannotSendInvitation}`, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
		else if (email !== '' && !ValidateEmail(email))
		{
			toast.error(`${language?.pleaseEnterValidEmail}`, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
		else if (addedEmail.includes(email))
		{
			toast.error(`${language?.emailAlreadyAdded}`, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
		else
		{
			setAddedEmail((prev) => [ ...prev, email ]);
			setEmail('');
		}
	};

	const handleRemove = (ItemD:any) =>
	{
		const removeData = addedEmail.filter((item) => item !== ItemD);

		setAddedEmail(removeData);
	};

	const copyLink = (e) =>
	{
		e.preventDefault();
		if (!blockRef.current)
		{
			setTitle('copied');
			blockRef.current = true;
			const dummy = document.createElement('textarea');

			document.body.appendChild(dummy);
			dummy.setAttribute('id', 'dummy_id');
			dummy.value = selectRole === 'company' ? companyUrl : employeeUrl;
			dummy.select();
			document.execCommand('copy');
			document.body.removeChild(dummy);
			toast.info(`${language?.copiedSuccess}`, {});
			setTimeout(() =>
			{
				blockRef.current = false;
				setTitle('copy');
			}, 5000);
		}
	};

	const handleInvite = () =>
	{
		setLoading(true);
		const body:any =
		{
			inviteLink  : selectRole === 'company' ? companyUrl : employeeUrl,
			inviteMails : addedEmail
		};

		SendInvitation(body)
			.then((res) =>
			{
				if (res.status)
				{
					toast.success(`${language?.inviteSentSuccess}`, {
						position  : toast.POSITION.TOP_RIGHT,
						className : 'toast-message'
					});
					props?.handleClose();
					setAddedEmail([]);
				}
				setLoading(false);
			})
			.catch((err) =>
			{
				if (err?.response?.data?.error)
				{
					const errMsg = Toasters(err.response.data.error);

					toast.error(errMsg !== 'null' ? language[errMsg] : err.response.data.error, {
						position  : toast.POSITION.TOP_RIGHT,
						className : 'toast-message'
					});
				}

				else
				{
					const errMsg = Toasters(err.message);

					toast.error(errMsg !== 'null' ? language[errMsg] : err.message, {
						position  : toast.POSITION.TOP_RIGHT,
						className : 'toast-message'
					});
				}
				setLoading(false);
			});
	};

	const handleSelect = (event:any) =>
	{
		setSelectRole(event.target.value);
	};

	return (
		<>
			{loading &&
				<Loading />
			}
			<div className='flexRow fxdRSliderHdr pdngVSM brdrBSM'>
				<div className='flexMinWidthRow alignCntr pdngHSM'>
					<span className='mainHdngTxt pdngHXS '>{language?.invite}</span>
				</div>
				<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && props?.handleClose(); }} className='flexAutoRow alignCntr pinter pdngRSM pointer' onClick={() => props?.handleClose()}>
					<CloseIcon />
				</button>
			</div>
			<div className='flexMinHeightCol pdngHXS scrollY'>
				<div className='flexCol pdngSM'>
					<span className='subHeadingSM'> {language?.inviteBusEcoSys}</span>
				</div>
				<div className='flexRow alignCntr pdngHSM'>
					<div className='flexAutoRow'>
						<span> {language?.chooseRole} &nbsp;</span>
					</div>
					<div className='flexMinWidthRow'>
						<FormControl fullWidth size='small'>
							<InputLabel id='demo-simple-select-label'>
								{language?.chooseRole}
							</InputLabel>
							<Select
								labelId='demo-simple-select-label'
								id='demo-simple-select'
								value={selectRole}
								placeholder={language?.minutes}
								label={language?.chooseRole}
								fullWidth
								onChange={handleSelect}
							>
								<MenuItem value='company'>{language?.company}</MenuItem>
								<MenuItem value='employee'>{language?.employee}</MenuItem>
							</Select>
						</FormControl>
					</div>
				</div>
				<div className='flexCol'>
					<span className='pdngSM'>{language?.copyInviteLink}</span>
					<div className='flexRow brdrBSM pdngBSM'>
						<div className='flexMinWidthRow pdngHSM'>
							<TextField
								fullWidth
								variant='outlined'
								type='text'
								size='small'
								className='modeGray'
								disabled
								value={selectRole === 'company' ? companyUrl : employeeUrl}
							/>
						</div>
						<div className='flexAutoRow pdngRSM'>
							<Button
								type='button'
								variant='contained'
								size='small'
								disableElevation
								disableRipple
								className='whiteTxt'
								onClick={copyLink}
							>
								{title === 'copy' ? language?.copy : language.copied}
							</Button>
						</div>
					</div>
				</div>
				<form onSubmit={(e) => { handleAdd(e); }}>
					<div className='flexCol pdngVSM'>
						<div className='flexRow mrgnBtmSM' >
							<div className='flexMinWidthRow pdngHSM'>
								<TextField
									fullWidth
									variant='outlined'
									type='email'
									size='small'
									placeholder={language?.enterEmailAdd}
									value={email}
									onChange={handleEmail}
								/>
							</div>
							<div className='flexAutoRow pdngRSM'>
								<Button type='submit' disableElevation disableRipple variant='contained' size='small' className='whiteTxt'>
									<Add />
								</Button>
							</div>
						</div>
					</div>
				</form>
				<div className='flexCol pdngSM' >
					{addedEmail && addedEmail?.map((item) =>
						(<div className='flexRow modeGray brdrRadiusSM alignCntr mrgnBXS' key={item}>
							<div className='flexMinWidthCol pdngHSM'>
								<span className='lightTxt wordBreakAll flexRow'>{item}</span>
							</div>
							<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleRemove(item); }} className='flexAutoRow alignCntr justifyCntr' onClick={() => handleRemove(item)}>
								<Tooltip title={language?.remove} placement='top'>
									<IconButton>
										<CloseIcon className='primaryTxt pointer'/>
									</IconButton>
								</Tooltip>
							</button>
						</div>
						))}
				</div>
			</div>
			<div className='flexRow pdngVMD justifyEnd alignCntr brdrTSM'>
				<span>
					<Button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && props?.handleClose(); }} disableElevation disableRipple variant='outlined' onClick={() => props?.handleClose()}>{language?.cancel}
					</Button>
				</span>
				<span className='pdngHMD'>
					<Button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleInvite(); }} disableElevation disableRipple variant='contained' className='whiteTxt' disabled={!(addedEmail.length > 0)} onClick={handleInvite}>
						{language?.send}
					</Button>
				</span>
			</div>
		</>
	);
};

export default EmployeeListSlider;